import type { CampaignMessageAssociationPort } from '@/domain/campaign-ports'
import { campaignService } from '@/services/campaign.service'
import { mapCampaignHttpError } from './campaign-http-error'

// HTTP-backed CampaignMessageAssociationPort — mirrors campaign-files-http-adapter.ts's
// CampaignFileAssociationPort exactly. There is no "list associated Messages"
// port/adapter here: that read is a plain frontend-only classificationApi.search +
// messageApi.get composition (useCampaignMessages, mirroring useWorkOrderMessages),
// not routed through this ports architecture — Messages have no server-side
// discover/pagination pipeline to justify one (design.md D3).

export const campaignMessageAssociationHttpAdapter: CampaignMessageAssociationPort = {
	async associateMessages(campaignId: string, messageIds: readonly string[]): Promise<void> {
		try {
			await campaignService.associateMessages(campaignId, messageIds)
		} catch (error) {
			throw mapCampaignHttpError(error)
		}
	},
}
